import { COLORS } from '../../../app/common/constants/styles';

export const getPayVaultStylesByScreenSize = (): Record<string, any> => {
    return window.screen.width > 900 ? pvLargeScreenElementStyles : pvSmallScreenElementStyles;
};

const pvCreditCardInputStyle = {
    color: `${COLORS.dark}`,
    border: `none`,
    'background-color': 'transparent',
    display: 'flex',
    'align-items': 'center',
    width: '100%',
    'font-size': '1rem',
    'line-height': '1.5',
};

const smallTextSize = {
    'font-size': '90%',
};

const pvLargeScreenElementStyles = {
    base: {
        ...pvCreditCardInputStyle,
    },
    valid: {
        ...pvCreditCardInputStyle,
    },
    invalid: {
        ...pvCreditCardInputStyle,
    },
    focus: {},
};

const pvSmallScreenElementStyles = {
    base: {
        ...pvCreditCardInputStyle,
        ...smallTextSize,
    },
    valid: {
        ...pvCreditCardInputStyle,
        ...smallTextSize,
    },
    invalid: {
        ...pvCreditCardInputStyle,
        ...smallTextSize,
    },
    focus: {
        ...pvCreditCardInputStyle,
        ...smallTextSize,
        'font-size': '90%',
    },
};
